import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api/cartera/cambios';
export const PAGE_SIZE = 50;

export const usePortfolioChanges = ({ estado, search, page }) => {
  const [data, setData] = useState({ items: [], total: 0 });
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const request = useRef(0);
  const load = useCallback(async () => {
    const version = ++request.current;
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(API, { params: { estado, search, skip: page * PAGE_SIZE, limit: PAGE_SIZE }, withCredentials: true });
      if (version !== request.current) return;
      setData(response.data);
      setSelected(response.data.items.filter(a => a.estado === 'cerrado' && a.puede_gestionar).map(a => a.id));
    } catch (e) {
      if (version === request.current) setError(e.response?.data?.detail || 'No se pudieron cargar los cambios de cartera.');
    } finally {
      if (version === request.current) setLoading(false);
    }
  }, [estado, search, page]);
  useEffect(() => {
    load();
    return () => { request.current += 1; };
  }, [load]);

  const confirm = async (rows) => {
    setSaving(true);
    try {
      const response = await axios.post(`${API}/mantener-cerrado`, {
        confirmar: true,
        activos: rows.map(a => ({ id: a.id, evento_id: a.cambio_cartera.evento_id, updated_at: a.updated_at })),
      }, { withCredentials: true });
      if (response.data.conflictos.length) toast.warning(`${response.data.confirmados.length} confirmados. Hay activos que cambiaron; revisa el listado actualizado.`);
      else toast.success(`${response.data.confirmados.length} activos confirmados: se mantienen cerrados.`);
      window.dispatchEvent(new Event('xenicos:refresh-cartera'));
      await load();
      return true;
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo confirmar la selección.');
      await load();
      return false;
    } finally { setSaving(false); }
  };
  return { data, selected, setSelected, loading, saving, error, load, confirm };
};